// Curated list of countries used as "Country of Origin" for industrial
// listings on IndusFact. Kept intentionally small (~30 entries) so the
// dropdown stays scannable and the data stays filterable.
// No free-text — if a country is missing, add it here so filters keep working.
//
// Order: India first (most common for our audience), then top industrial
// origin countries by relevance to Indian buyers of used machinery.

export const COUNTRIES_OF_ORIGIN = [
  'India',
  'Japan',
  'Germany',
  'USA',
  'China',
  'South Korea',
  'Taiwan',
  'Italy',
  'United Kingdom',
  'France',
  'Switzerland',
  'Sweden',
  'Spain',
  'Turkey',
  'Austria',
  'Netherlands',
  'Belgium',
  'Czech Republic',
  'Poland',
  'Brazil',
  'Mexico',
  'Canada',
  'Australia',
  'Singapore',
  'Malaysia',
  'Thailand',
  'Vietnam',
  'UAE',
  'Israel',
  'Russia',
  'Finland',
  'Denmark',
  'Portugal',
  'South Africa',
];

// Country → emoji flag map (nice-to-have for the ListingDetail specs +
// card badge). Only the countries above are mapped; anything else falls
// back to no flag. Kept as a helper — not a component prop.
export const COUNTRY_FLAG = {
  India: 'IN', Japan: 'JP', Germany: 'DE', USA: 'US', China: 'CN',
  'South Korea': 'KR', Taiwan: 'TW', Italy: 'IT', 'United Kingdom': 'GB',
  France: 'FR', Switzerland: 'CH', Sweden: 'SE', Spain: 'ES', Turkey: 'TR',
  Austria: 'AT', Netherlands: 'NL', Belgium: 'BE', 'Czech Republic': 'CZ',
  Poland: 'PL', Brazil: 'BR', Mexico: 'MX', Canada: 'CA', Australia: 'AU',
  Singapore: 'SG', Malaysia: 'MY', Thailand: 'TH', Vietnam: 'VN',
  UAE: 'AE', Israel: 'IL', Russia: 'RU', Finland: 'FI', Denmark: 'DK',
  Portugal: 'PT', 'South Africa': 'ZA',
};
